/**
 * ContentIconsPart
 *
 * @author: exode <hello@exode.ru>
 */

import React from 'react';

import { IS_BIZ_WELCOME } from '@/root/src/env';

import { RouterStore } from '@/store/core/router';
import { UserAuthStore } from '@/store/user/auth';
import { observer, ShopStore } from '@/store/user/shop';
import { PreferenceStore } from '@/store/preference/preference';

import { PageSpace } from '@/shared/types';
import { useNotificationUnread } from '@/hooks/apollo';
import { Auth, If, Link, Platform, Responsive } from '@/cutils';

import { Avatar, Counter, TabbarItem } from '@exode.ru/vkui';
import { Icon28MoonOutline, Icon28ShoppingCartOutline, Icon28SunOutline } from '@vkontakte/icons';

import { HeaderItem } from '@/components/Desktop/Panel';
import { PreferenceThemeToggle } from '@/components/Preference/Theme';

import { ChatHeaderItemPart } from '../parts/ChatHeaderItem';
import { NotificationHeaderItemPart } from '../parts/NotificationHeaderItem';


const ContentIconsPart = observer(() => {

    const { unreadCountNotification } = useNotificationUnread();

    return (
        <>
            <Platform.If platforms={[
                PageSpace.SchoolPlatform,
                PageSpace.MarketplacePlatform,
            ]}>
                <If is={!!ShopStore.cartLength}>
                    <Link disabled pushPage={{ id: '/cart' }}>
                        <HeaderItem className="next-release bg-transparent">
                            <TabbarItem indicator={(
                                <Counter mode="prominent" size="s">
                                    {ShopStore.cartLength}
                                </Counter>
                            )}>
                                <Icon28ShoppingCartOutline fill="var(--accent)"/>
                            </TabbarItem>
                        </HeaderItem>
                    </Link>
                </If>

                <Auth>
                    <NotificationHeaderItemPart count={unreadCountNotification}/>
                </Auth>
            </Platform.If>

            <Responsive.DesktopOnly>
                <If is={(
                    RouterStore.type !== 'iframe'
                    || !UserAuthStore.isLoggedIn
                    || IS_BIZ_WELCOME
                )}>
                    <If is={!PreferenceStore.toggleIsDisabled}>
                        <PreferenceThemeToggle>
                            <HeaderItem className="bg-transparent">
                                <Avatar size={35} shadow={false}>
                                    <If is={PreferenceStore.isDark}>
                                        <Icon28SunOutline className="text-accent"/>
                                    </If>

                                    <If is={!PreferenceStore.isDark}>
                                        <Icon28MoonOutline className="text-accent"/>
                                    </If>
                                </Avatar>
                            </HeaderItem>
                        </PreferenceThemeToggle>
                    </If>
                </If>

                <Auth>
                    <If is={!IS_BIZ_WELCOME && RouterStore.type === 'iframe'}>
                        <Link pushPage={{ id: '/chat' }}>
                            <ChatHeaderItemPart/>
                        </Link>
                    </If>
                </Auth>
            </Responsive.DesktopOnly>
        </>
    );
});


export { ContentIconsPart };
